import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationExtras, Router } from '@angular/router';
import { AddCardDialogComponent } from 'src/app/payment/add-card-dialog/add-card-dialog.component';
@Component({
  selector: 'app-breadcrumb-nav',
  templateUrl: './breadcrumb-nav.component.html',
  styleUrls: ['./breadcrumb-nav.component.scss']
})
export class BreadcrumbNavComponent implements OnInit {
  public smallDevices: boolean;
  public largeDevices: boolean;
  @Input() breadCrumbData: string;
  @Input() menuData: any;
  @Input() storeDetails:any;
  breadCrumbLen:number;
  constructor(private breakpointObserver: BreakpointObserver,private router:Router, public dialog: MatDialog,) {
  }
  ngOnInit(): void {
    this.breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium,
      Breakpoints.Large,
      Breakpoints.XLarge
    ]).subscribe((state: BreakpointState) => {
      if (state.breakpoints[Breakpoints.XSmall]) {
        this.smallDevices = true;
        this.largeDevices = false;
      }
      if (state.breakpoints[Breakpoints.Small]) {
        this.smallDevices = true;
        this.largeDevices = false;
      }
      if (state.breakpoints[Breakpoints.Medium]) {
        this.largeDevices = true;
        this.smallDevices = false;
      }
      if (state.breakpoints[Breakpoints.Large]) {
        this.largeDevices = true;
        this.smallDevices = false;
      }
      if (state.breakpoints[Breakpoints.XLarge]) {
        this.largeDevices = true;
        this.smallDevices = false;
      }
    });
    this.breadCrumbLen = this.breadCrumbData && this.breadCrumbData.length;
  }
  navigateTo(i,index){
    const navigationExtras: NavigationExtras = {
      state: {
        data:this.menuData,
        storeDetails:this.storeDetails,
        module:'breadcrumb'
     }
    };
    if(i.title == 'Pay'){
      const dialogRef = this.dialog.open(AddCardDialogComponent, {
        width: '744px',
        panelClass: "dialog-no-padding"
      });
    }
    if(index<this.breadCrumbLen){
      this.router.navigate(['/'+i.path],navigationExtras)
    }
  }
}
